// Check if a date string is within [from, to] inclusive; to covers end-of-day
export const withinRange = (dateStr, from, to) => {
  if (!from && !to) return true;
  if (!dateStr) return false;
  const d = new Date(dateStr);
  if (from && d < new Date(from)) return false;
  if (to && d > new Date(new Date(to).setHours(23, 59, 59, 999))) return false;
  return true;
};
export const formatDateTimePretty = (val, offset) => {
  if (!val) return "—";
  let d = new Date(val);
  if (isNaN(d.getTime())) return "—";

  if (offset) {
    const sign = offset.startsWith("-") ? -1 : 1;
    const match = offset.match(/\d{1,2}/g);
    const hrs = match && match[0] ? parseInt(match[0], 10) : 0;
    const mins = match && match[1] ? parseInt(match[1], 10) : 0;
    const offsetMs = sign * ((hrs * 60) + mins) * 60 * 1000;

    const localTime = d.getTime() + offsetMs;
    d = new Date(localTime);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[d.getUTCMonth()];
    const year = d.getUTCFullYear();
    const h = String(d.getUTCHours()).padStart(2, "0");
    const m = String(d.getUTCMinutes()).padStart(2, "0");
    return `${day} ${month} ${year} ${h}:${m}`;
  } else {
    const day = String(d.getDate()).padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    const h = String(d.getHours()).padStart(2, "0");
    const m = String(d.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year} ${h}:${m}`;
  }
};